import PropTypes from 'prop-types';

import React, { useState } from 'react';
import {
	ButtonDropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from 'reactstrap';

import styled from 'styled-components';

import kebabImage from 'svgs/kebab';

/**
 * <KebabMenuCell />, a three-dot (kebab) toggle that opens a dropdown of actions.
 *
 * The menu is right-aligned by default (its right edge sits under the toggle's
 * right edge and it grows leftward) because every table usage puts the kebab in
 * the last column. When the kebab sits at the LEFT of its container — e.g. next
 * to the patient name on the Measures page — a right-aligned menu grows off the
 * left edge of the viewport, so pass `alignRight={false}` there.
 */

const Kebab = styled.div`
	path {
		fill: ${(props) => (props.isActive ? 'var(--main-color)' : 'black')};
	}
`;
const KebabMenuCell = (props) => {
	const {
		dropdownItems = [],
		noMargin,
		direction = 'down',
		alignRight = true,
	} = props;
	const [isOpen, setIsOpen] = useState(false);

	const handleClick = (callback, args = []) => {
		callback(...args);
	};

	const toggle = () => {
		setIsOpen(!isOpen);
	};

	return (
		<div className={`d-flex justify-content-end ${!noMargin && 'mr-4'} mt-1`}>
			<ButtonDropdown
				nav
				inNavbar
				direction={direction}
				isOpen={isOpen}
				toggle={toggle}
			>
				<DropdownToggle nav>
					<Kebab
						className={`d-flex justify-content-end ${!noMargin && 'mr-4'}`}
						isActive={isOpen}
					>
						{kebabImage}
					</Kebab>
				</DropdownToggle>
				<DropdownMenu right={alignRight} flip={false}>
					{dropdownItems.map(
						(item) =>
							item.enabled && (
								<DropdownItem
									key={item.id}
									onClick={() => {
										handleClick(item.callback, item.args);
									}}
								>
									{item.name}
								</DropdownItem>
							),
					)}
				</DropdownMenu>
			</ButtonDropdown>
		</div>
	);
};

KebabMenuCell.propTypes = {
	dropdownItems: PropTypes.array,
	noMargin: PropTypes.bool,
	direction: PropTypes.string,
	alignRight: PropTypes.bool,
};

export default KebabMenuCell;
